import styled from 'styled-components';

export const ClubTypesWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

export const ClubTypeTag = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: #ffffff;
  border: 1.5px solid #e5e7eb;
  padding: 1rem 1.75rem;
  border-radius: 50px;
  font-size: 1.05rem;
  font-weight: 600;
  color: #1f2937;
  transition: border-color 0.2s;

  &:hover {
    border-color: #1f2937;
  }
`;

export const ClubTypeEmoji = styled.span`
  font-size: 1.4rem;
`;
